import React, { type FC, type PropsWithChildren } from 'react';
import { useWiredComponents } from '../../context/TopProps';
import { type WiredTextProps } from './types';

export const Text: FC<PropsWithChildren<WiredTextProps>> = ({ children, ...props }) => {
  const WiredComponents = useWiredComponents();

  if (WiredComponents?.Text) {
    return <WiredComponents.Text {...props}>{children}</WiredComponents.Text>;
  }

  return <span {...props}>{children}</span>;
};
